import { render, staticRenderFns } from "./PlayerAlternative.vue?vue&type=template&id=511fdd4c&scoped=true&"
import script from "./PlayerAlternative.vue?vue&type=script&lang=js&"
export * from "./PlayerAlternative.vue?vue&type=script&lang=js&"
import style0 from "./PlayerAlternative.vue?vue&type=style&index=0&id=511fdd4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511fdd4c",
  null
  
)

export default component.exports